import Cookies from 'universal-cookie';

import { COOKIE_CHAT_STARTED_FROM_GREETING } from 'src/constants/cookie.constants';

import { pushToDataLayer } from './pushToDataLayer';

const cookies = new Cookies();

type ConversionType = 'deposit' | 'create_account' | 'finance_quote_submit' | 'pdp_enquiry' | 'trade_sell_form';

/**
 * Records a conversion event if the user previously started a chat from a greeting.
 * This function checks for the chatStartedFromGreeting cookie and sends a conversion
 * event to the data layer if the cookie exists. The cookie persists to allow tracking
 * of multiple conversion events.
 *
 * @param conversionType - The type of conversion (e.g., 'purchase', 'signup', 'quote_request')
 */
export const recordChatConversion = (conversionType: ConversionType) => {
  const chatStartedFromGreeting = cookies.get(COOKIE_CHAT_STARTED_FROM_GREETING);

  if (!!chatStartedFromGreeting) {
    pushToDataLayer({
      event: 'chat_auto_prompt',
      event_type: 'conversion',
      conversion_type: conversionType,
    });
  }
};
